import React from 'react'
// Import Img
import Img1 from "../../assets/img/volunteer/volunteer-1.png"
import Img2 from "../../assets/img/volunteer/volunteer-2.png"
import Img3 from "../../assets/img/volunteer/volunteer-3.png"
import Img4 from "../../assets/img/volunteer/volunteer-4.png"

const ReadyHelp = () => {
    const ReadyData = [
        {
            img:Img1,
            name:"Amina Rahman",
            title:"Board chair"
        },
        {
            img:Img2,
            name:"Omar Siddiqui",
            title:"Badminton & sports coordinator"
        },
        {
            img:Img3,
            name:"Sana Malik",
            title:"Education & integration lead"
        },
        {
            img:Img4,
            name:"Hassan Iqbal",
            title:"Youth mentor"
        }
    ]
  return (
    <>
        <section id="volunteer_area" className="section_after section_padding_top bg-color">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="section_heading">
                        <h3>Our volunteers</h3>
                        <h2> Coaches, tutors, and organisers who
                            <span className="color_big_heading"> care</span> about every child</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                {ReadyData.map((data, index)=>(
                     <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={index}>
                     <div className="volunteer_wrapper">
                         <div className="volunteer_img">
                             <img src={data.img} alt="img" />
                             <div className="volunteer_icon">
                                 <ul>
                                     <li>
                                         <a href="#!"><i className="fab fa-facebook"></i></a>
                                     </li>
                                     <li>
                                         <a href="#!"><i className="fab fa-twitter-square"></i></a>
                                     </li>
                                     <li>
                                         <a href="#!"><i className="fab fa-instagram"></i></a>
                                     </li>
                                     <li>
                                         <a href="#!"><i className="fab fa-linkedin"></i></a>
                                     </li>
                                 </ul>
                             </div>
                         </div>
 
                         <div className="volunteer_text">
                             <h3><a href="#!">{data.name}</a></h3>
                             <p>{data.title}</p>
                         </div>
                     </div>
                 </div>
                ))}
            </div>
        </div>
    </section>
    </>
  )
}

export default ReadyHelp